module.exports = __webpack_public_path__ + "img/step3.f262df06.png";